
<div class="articles-container">
  <div class="container">
    <div class="section-box">
      <div data-aos="fade-up" data-aos-duration="1000">
        <h3 class="section-title">
           &nbsp;Articles&nbsp;<i class="far fa-newspaper"></i>
        </h3>
        
      </div>
    </div>
    <p>Your articles content goes here</p>
  </div>
  
</div>